import { AzureAdClientOptions } from "./azure-ad";


interface ClientOptions extends AzureAdClientOptions {
    apiScopes: Array<string>,
    graphScopes: Array<string>,
    apiBaseUrl: string
}

export function clientConfig(): ClientOptions {

    return {
        authority: 'https://login.microsoftonline.com/9bd9c4da-6849-4d5a-a6d3-4dec12d2878b',
        clientId: 'e0462e88-05b8-436a-9b2c-e3d4f989685e',
        graphScopes: ['https://graph.microsoft.com/User.ReadBasic.All'],
        apiScopes: ["api://6cd19501-a486-405f-a0ca-a6649e242fee/Subscribers.ReadWrite", "api://6cd19501-a486-405f-a0ca-a6649e242fee/Directory.ReadWrite"],
        redirectUrl: process.env.PUBLIC_URL,
        postLogoutRedirectUri: process.env.PUBLIC_URL,
        apiBaseUrl: `${process.env.PUBLIC_URL}/api`,
    }
}